export const DEFAULT_DUPLICATE_ACTION_WINDOW_MS = 750;

type TimeProvider = () => number;

/**
 * Tracks the last accepted action for each control without retaining controls
 * after they are removed from the page.
 */
export class DuplicateActionTracker {
	private readonly lastAcceptedAt = new WeakMap<object, number>();

	constructor(
		private readonly windowMs = DEFAULT_DUPLICATE_ACTION_WINDOW_MS,
		private readonly now: TimeProvider = () => performance.now(),
	) {}

	isDuplicate(target: object): boolean {
		const currentTime = this.now();
		const previousTime = this.lastAcceptedAt.get(target);

		if (previousTime !== undefined && currentTime >= previousTime && currentTime - previousTime < this.windowMs) {
			return true;
		}

		this.lastAcceptedAt.set(target, currentTime);
		return false;
	}
}
